import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  mergeAllDataIntoFormData,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  CREATE_PAYMENT_TERMS,
  DELETE_PAYMENT_TERMS,
  EIDT_PAYMENT_TERMS,
  GET_PAYMENTTERMS_BYID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { PaymentTermsFields } from "./AddPaymentTerms.Config";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";

const AddPaymentTermsMaster = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Payment Terms Master");
  const Form_Key = "Payment_Terms";
  const { pushModal, popModal } = useModalContext();
  const formRef = useRef({});
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Payment_Terms?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState({});
  const [FormData, setFormdata] = useState({});
  const dispatch = useDispatch();

  //Q & M
  const [CreatingData, { loading: CreatePayment }] = useMutation(CREATE_PAYMENT_TERMS);

  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(GET_PAYMENTTERMS_BYID);

  const [EditingData, { loading: EditPayment }] = useMutation(EIDT_PAYMENT_TERMS);

  const [DeletingData, { loading: DeletePayment }] = useMutation(DELETE_PAYMENT_TERMS);

  const isLoading = CreatePayment || EditPayment || DeletePayment || GetDataByIDLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Payment_Terms?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
      GetDataByID({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        let PaymentMasterData = { ...data?.getEMTPaymentTermsMasterById };
        setAllFieldsData(PaymentMasterData);
        updateValueForm(formRef, PaymentMasterData);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
  };

  const submit = async (closeAction) => {
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
        OnSuccess: (res) => {
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  if (TypeOfPortal === "Delete Payment Terms Master" || modifiedTypeOfPortal === "Delete Payment Terms Master") {
    return (
      <Reactportal
        open={toggle}
        onClose={() => settoggle(false)}
        TypeOfPortal={"Confirm"}
        // //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={isLoading}
        />
      </Reactportal>
    );
  }
  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={submit}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
   
      SaveAndClose={TypeOfPortal === "Add" ? SaveAndCloseForAdd : submit}
      handleformclose={() => {
        settoggle(!toggle);
      }}
      loadingState={isLoading}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
        >
          <>
            {isLoading && <div className="loader-line-div" />}
            <div className="formContainer">
              {PaymentTermsFields.map((e, i) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        onhandleFormikChange={HanldeChangeonForm}
                        formkey={Form_Key}
                        formRef={formRef}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddPaymentTermsMaster;
